import {styled, DropdownMenuStyled} from "@reside/ui";

export const DropdownMenu = styled(DropdownMenuStyled)`
  margin-top: 8px;
  padding: 0px;
  width: 360px;
  z-index: 1001;
  display: flex;
  flex-direction: column;
  max-height: 80vh;

  .rc-tree {
    flex: 1;
    overflow-y: auto;
    min-height: 100px;
  }
`;

export const Trigger = styled.div`
  &:hover {
    cursor: pointer;
  }
  display: grid;
  grid-template-columns: auto 1fr auto;
  grid-template-areas: "label value icon";
  align-items: center;
  text-align: left;
  gap: 4px;

  @media (max-width: 1024px) {
    max-width: 480px;
  }

  @media (max-width: 768px) {
    max-width: 280px;
  }
`;

export const TriggerLabel = styled.span`
  grid-area: label;
  font-size: 14px;
  font-weight: 500;
`;

export const TriggerValue = styled.strong`
  grid-area: value;
  font-size: 14px;
`;

export const TriggerIconWrapper = styled.div`
  grid-area: icon;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
